import './Intro.scss'
import { KeyboardArrowDown } from '@mui/icons-material'
import { init } from 'ityped'
import { useEffect, useRef } from 'react'

export default function Intro() {
  const textRef = useRef()

  // List of elements to type
  useEffect(() => {
    init(textRef.current, {
      showCursor: true,
      backDelay: 1500,
      backSpeed: 60,
      strings: ['Engineer', 'Developer'],
    })
  }, [])

  return (
    <div className='intro' id='intro'>
      <div className='left'>
        <div className='wrapper'>
          <h2>Hi! I'm</h2>
          <h1> Flynn Pyc</h1>
          <h3>
            Front End <span ref={textRef}></span>
          </h3>
          <p>
            I like making things that solve problems, are easy to use, and make
            people feel good.
          </p>
          <a
            href='\assets\Resume_Flynn_2022.pdf'
            target='_blank'
            rel='noreferrer'
            className='button'
            alt='Download Resume'
          >
            Download Resume
          </a>

          <a href='#portfolio' title='to Portfolio' className='arrowDown'>
            <KeyboardArrowDown />
          </a>
        </div>
      </div>

      <div className='right'>
        <div className='imgContainer'>
          <img src='assets/profile-nobg.png' alt='' />
        </div>
      </div>
    </div>
  )
}
